"use client";
import React, { useState, useRef, useEffect, useContext } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useSubscription } from "../context/SubscriptionContext";
import { Box } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useCart } from "../context/CartContext";
import { useLocation } from "react-router-dom";
import { UPLOAD_URL } from "../config/apiConfig";
import { useProfile } from "../context/ProfileContext";
import { AuthContext } from "../context/AuthContext";
import { BASE_URL } from "../config/apiConfig";
 
const Header = () => {
  const { user, logout } = useContext(AuthContext);
  const [subscribed, setSubscribed] = useState(false);
  // const { token } = useSubscription();
  const [activePlanId, setActivePlanId] = useState(null);
    const token = localStorage.getItem("auth_token");

 
  // useEffect(() => {
  //   const subId = localStorage.getItem("sub_id");
  //   setSubscribed(!!subId);
  // }, [user]);

  useEffect(() => {
  if (!token) return;

  const userId = localStorage.getItem("user_id");
  if (!userId) return;

  const fetchActiveSubscription = async () => {
    try {
      const res = await fetch(`${BASE_URL}/mysubscriptions/${userId}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await res.json();

      if (data.status === 200 && Array.isArray(data.data)) {
        const activeSub = data.data.find(
          sub => sub.status === "active" && sub.payment_status === "paid"
        );

        if (activeSub) {
          localStorage.setItem("sub_id", activeSub.id);
          localStorage.setItem("plan_id", activeSub.plan_id);
          setActivePlanId(activeSub.plan_id);
          setSubscribed(true);   // ✅ HERE
        } else {
          localStorage.removeItem("sub_id");
          localStorage.removeItem("plan_id");
          setActivePlanId(null);
          setSubscribed(false);  // ✅ HERE
        }
      } else {
        setSubscribed(false);
      }
    } catch (err) {
      console.error("Failed to fetch active subscription:", err);
      setSubscribed(false);
    }
  };

  fetchActiveSubscription();
}, [token]);

 
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isProfileDropdownOpen, setIsProfileDropdownOpen] = useState(false);
  const [showMobileProfile, setShowMobileProfile] = useState(false);
 
  const profileDropdownRef = useRef(null);
  const mobileMenuRef = useRef(null);
  const navigate = useNavigate();
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
 
  const { profile } = useProfile();
 
  const [userName, setUserName] = useState("");
  const [userImage, setUserImage] = useState("");
  const [isLoggedIn, setIsLoggedIn] = useState(false);
 
  useEffect(() => {
    const storedUser = localStorage.getItem('auth_user');
    if (storedUser) {
      try {
        const parsedUser = JSON.parse(storedUser);
        setUserName(parsedUser.name || 'User');
        const imageUrl = parsedUser.image?.startsWith('http')
          ? parsedUser.image
          : `${UPLOAD_URL}/users/${parsedUser.image}`;
        setUserImage(imageUrl);
        setIsLoggedIn(true);
      } catch (err) {
        console.error('Failed to parse user info:', err);
        setIsLoggedIn(false);
      }
    } else {
      setIsLoggedIn(false);
    }
  }, []);
 
  const handleLogout = () => {
    localStorage.removeItem("auth_token");
    localStorage.removeItem("user_id");
    localStorage.removeItem("auth_user");
    localStorage.removeItem("sub_id");
    localStorage.removeItem("plan_id");
    localStorage.removeItem("uemail");
    setIsLoggedIn(false);
    window.location.href = "/login";
  };
 
  const location = useLocation();
 
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const searchTerm = params.get("search") || "";
    setSearchQuery(searchTerm);
  }, [location.search]);
 
  const handlelogo = () => {
    navigate('/');
  };
 
  useEffect(() => {
    if (profile) {
      setUserName(`${profile.first_name} ${profile.last_name}`);
      setUserImage(
        profile.image?.startsWith('http')
          ? profile.image
          : `${UPLOAD_URL}/users/${profile.image}`
      );
      setIsLoggedIn(true);
    }
  }, [profile]);
 
  useEffect(() => {
    const handleClickOutside = (event) => {
      const mobileMenuButton = event.target.closest('[aria-label="Toggle mobile menu"]');
      if (mobileMenuButton) {
        return;
      }
 
      if (profileDropdownRef.current && !profileDropdownRef.current.contains(event.target)) {
        setIsProfileDropdownOpen(false);
      }
      if (mobileMenuRef.current && !mobileMenuRef.current.contains(event.target)) {
        setIsMobileMenuOpen(false);
        setShowMobileProfile(false);
      }
    };
 
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
 
  const handleKeyDown = (event, action) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      action();
    }
    if (event.key === "Escape") {
      setIsProfileDropdownOpen(false);
      setIsMobileMenuOpen(false);
      setShowMobileProfile(false);
    }
  };
 
  const toggleMobileMenu = (event) => {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
    setIsMobileMenuOpen(prev => !prev);
    if (isMobileMenuOpen) {
      setShowMobileProfile(false);
    }
  };
 
  const toggleMobileProfile = (event) => {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
    setShowMobileProfile(prev => !prev);
  };
 
  const toggleProfileDropdown = () => {
    setIsProfileDropdownOpen(!isProfileDropdownOpen);
  };
 
  const [searchQuery, setSearchQuery] = useState(() => {
    return "";
  });
 
  const handleSearch = (e) => {
    e.preventDefault();
    const trimmedQuery = searchQuery.trim();
    if (trimmedQuery !== "") {
      const encodedQuery = encodeURIComponent(trimmedQuery);
      navigate(`/products?search=${encodedQuery}`);
      setIsMobileMenuOpen(false);
      if (encodedQuery && location.pathname === "/products") {
        window.history.replaceState({}, "", "/products");
      }
          setTimeout(() => setSearchQuery(""), 100);
    }
  };
 
  const handleNavigation = (route) => {
    navigate(route);
    setIsMobileMenuOpen(false);
    setShowMobileProfile(false);
    setIsProfileDropdownOpen(false);
  };
 
  const handleLoginClick = () => {
    navigate('/login');
    setIsMobileMenuOpen(false);
  };
 
  const menuVariants = {
    closed: {
      opacity: 0,
      y: -20,
      transition: {
        duration: 0.2,
        ease: "easeInOut"
      }
    },
    open: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.3,
        ease: "easeOut"
      }
    }
  };
 
  const dropdownVariants = {
    closed: {
      opacity: 0,
      scale: 0.95,
      y: -10,
      transition: {
        duration: 0.2,
        ease: "easeInOut"
      }
    },
    open: {
      opacity: 1,
      scale: 1,
      y: 0,
      transition: {
        duration: 0.2,
        ease: "easeOut"
      }
    }
  };
 
  const mobileMenuItems = [
    { label: "Home", route: "/" },
    { label: "Products", route: "/products" },
  ];
 
  const profileMenuItems = isLoggedIn
    ? [
        { label: "My Profile", route: "/profile" },
        { label: "My Orders", route: "/profile/orders" },
        { label: "Settings", route: "/profile/settings" },
        { label: "Log Out", route: "/login" },
      ]
    : [{ label: "Login", route: "/login" }];
 
  const { cart } = useCart();
  const count = Array.isArray(cart) ? cart.length : 0;
 
  const scart = JSON.parse(localStorage.getItem("sub_cart")) || [];
  const scount = Array.isArray(scart) ? scart.length : 0;
 
  const displayCount = scount > 0 ? scount : count;
 
  // Helper function to get user initials
  const getUserInitials = (name) => {
    if (!name || typeof name !== 'string') return 'U';
    const names = name.trim().split(' ');
    if (names.length >= 2) {
      return (names[0][0] + names[names.length - 1][0]).toUpperCase();
    }
    return name[0].toUpperCase();
  };
 
  // Helper function to get background color based on name
  const getAvatarColor = (name) => {
    if (!name) return 'bg-blue-500';
    const colors = [
      'bg-blue-500',
      'bg-green-500',
      'bg-purple-500',
      'bg-pink-500',
      'bg-indigo-500',
      'bg-yellow-500',
      'bg-red-500',
      'bg-teal-500'
    ];
    const index = name.charCodeAt(0) % colors.length;
    return colors[index];
  };
 
  // Profile Avatar Component
  const ProfileAvatar = ({
    size = "w-10 h-10",
    textSize = "text-sm",
    showImage = true,
  }) => {
    const [imageLoaded, setImageLoaded] = useState(false);
    const [imageError, setImageError] = useState(false);
 
    const initials = getUserInitials(userName);
    const bgColor = getAvatarColor(userName);
 
    const hasImage = showImage && userImage && !imageError;
 
    return (
      <div className={`relative ${size} shrink-0`}>
        {/* Fallback initials */}
        {(!hasImage || !imageLoaded) && (
          <div
            className={`absolute inset-0 flex items-center justify-center rounded-full text-white font-bold select-none ${bgColor} ${textSize}`}
          >
            {initials}
          </div>
        )}
 
        {/* User image */}
        {hasImage && (
          <img
            src={userImage}
            alt="User Avatar"
            className={`object-cover rounded-full ${size}`}
            onLoad={() => setImageLoaded(true)}
            onError={() => {
              setImageError(true);
              setImageLoaded(false);
            }}
            style={{
              display: imageLoaded ? "block" : "none",
            }}
          />
        )}
      </div>
    );
  };
 
  return (
    <motion.header
      className="sticky top-0 z-50 shadow-[0px_11px_44px_rgba(0,0,0,0.1)]"
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.5, ease: "easeOut" }}
    >
      <div className="flex flex-col justify-center px-4 py-4 w-full bg-white lg:px-6 xl:px-10">
        <div className="flex gap-4 justify-between items-center w-full">
          {/* Logo Section */}
          <motion.div
            className="flex gap-3 justify-center items-center text-2xl font-bold text-black flex-shrink-0 cursor-pointer"
            whileHover={{ scale: 1.02 }}
            transition={{ duration: 0.2 }}
            onClick={handlelogo}
          >
            <img
              src="https://cdn.acsdev.in/Rentastic/rentastic.png"
              alt="Rentastic Toys Logo"
              className="object-contain shrink-0 bg-blend-normal aspect-square w-[52px]"
            />
            <div>Rentastic toys</div>
          </motion.div>
 
          {/* Search Bar - Desktop */}
          <div className="hidden md:block flex-1 max-w-lg mx-2 xl:mx-4">
            <form onSubmit={handleSearch} className="relative">
              <div className="flex items-center ps-5 pe-2 py-1 border border-solid bg-neutral-50 border-black border-opacity-10 rounded-[90px]">
                <input
                  type="search"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  placeholder="Find for product"
                  className="flex-1 bg-transparent text-sm font-medium text-neutral-600 outline-none"
                  aria-label="Search for products"
                />
                <motion.button
                  type="submit"
                  className="ml-3 p-3 bg-[#7299ff] text-white rounded-full hover:bg-blue-600 transition-colors duration-200"
                  whileHover={{ scale: 1.1 }}
                  whileTap={{ scale: 0.95 }}
                  aria-label="Search"
                >
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                  </svg>
                </motion.button>
              </div>
            </form>
          </div>
 
          {/* Right Section - Icons and Profile */}
          <div className="flex gap-2 xl:gap-3.5 items-center flex-shrink-0">
            {/* Mobile Menu Button */}
            <motion.button
              className="lg:hidden p-2 text-gray-700 hover:text-black"
              onClick={(e) => toggleMobileMenu(e)}
              onKeyDown={(e) => handleKeyDown(e, () => toggleMobileMenu(e))}
              whileTap={{ scale: 0.95 }}
              aria-label="Toggle mobile menu"
              aria-expanded={isMobileMenuOpen}
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                {isMobileMenuOpen ? (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </motion.button>
 
            {/* Conditional rendering based on login status */}
            {isLoggedIn ? (
              <>
                {/* Subscribe Button - Only show when logged in */}
                {!subscribed && (
                  <motion.button
                    onClick={() => {
                      const user = JSON.parse(localStorage.getItem("auth_user"));
                      if (!user) {
                        navigate("/login");
                      } else {
                        navigate("/profile/subscription");
                      }
                    }}
                    className="hidden lg:block bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600 transition"
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                  >
                    Subscribe
                  </motion.button>
                )}
 
                {/* Wishlist Icon - Desktop Only - Only show when logged in */}
                <motion.button
                  className="hidden lg:block relative p-2 text-gray-700 hover:text-red-500 transition-colors duration-200"
                  whileHover={{ scale: 1.1 }}
                  whileTap={{ scale: 0.95 }}
                  aria-label="Wishlist"
                  onClick={() => {
                    const user = JSON.parse(localStorage.getItem("auth_user"));
                    const plan_id = localStorage.getItem("plan_id");
                  
                    const isSubscribed = user?.subscription?.status === "active";
                  
                    if (isSubscribed || plan_id) {
                      // If user has an active subscription or plan_id exists, go to wishlist
                      navigate("/wishlist");
                    } else {
                      // Otherwise, redirect to subscription page
                      navigate("/profile/subscription");
                    }
                  }}
 
                >
                  <svg
                    className="w-6 h-6"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
                    />
                  </svg>
                </motion.button>
 
                {/* Cart Icon with Badge - Desktop Only - Only show when logged in */}
                <motion.button
                  className="hidden lg:block relative p-2 text-gray-700 hover:text-black transition-colors duration-200"
                  whileHover={{ scale: 1.1 }}
                  whileTap={{ scale: 0.95 }}
                  onClick={() => {
                    const user = JSON.parse(localStorage.getItem("auth_user"));
                    const plan_id = localStorage.getItem("plan_id");
                    const isSubscribed = user?.subscription?.status === "active";

                    // Parse the sub_cart safely
                    const subCartRaw = localStorage.getItem("sub_cart");
                    let subCart = [];

                    try {
                      subCart = subCartRaw ? JSON.parse(subCartRaw) : [];
                    } catch {
                      subCart = [];
                    }

                    // Redirect logic
                    if (isSubscribed || plan_id || (Array.isArray(subCart) && subCart.length > 0)) {
                      // User subscribed, has a plan, or has items in cart
                      navigate("/cartSection");
                    } else {
                      // Otherwise, go to subscription
                      navigate("/profile/subscription");
                    }
                  }}

                  aria-label="Shopping cart"
                >
                  <div className="relative">
                    <Box className="w-6 h-6" strokeWidth={2} />
                    {displayCount > 0 && (
                      <motion.div
                        className={`absolute -top-2 -right-2 flex items-center justify-center w-5 h-5 ${
                          scount > 0 ? "bg-green-400" : "bg-yellow-400"
                        } rounded-full`}
                        initial={{ scale: 0 }}
                        animate={{ scale: 1 }}
                        transition={{ type: "spring", stiffness: 500 }}
                      >
                        <span className="text-xs font-bold text-gray-800">{displayCount}</span>
                      </motion.div>
                    )}
                  </div>
                </motion.button>
 
                {/* User Profile - Desktop Only - Only show when logged in */}
                <div className="hidden lg:block relative" ref={profileDropdownRef}>
                  <motion.button
                    className="flex gap-2 xl:gap-3.5 items-center text-black hover:bg-gray-50 rounded-lg p-2 transition-colors duration-200"
                    onClick={toggleProfileDropdown}
                    onKeyDown={(e) => handleKeyDown(e, toggleProfileDropdown)}
                    whileHover={{ scale: 1.02 }}
                    whileTap={{ scale: 0.98 }}
                    aria-label="User profile menu"
                    aria-expanded={isProfileDropdownOpen}
                    aria-haspopup="true"
                  >
                    <ProfileAvatar />
                    <div className="hidden xl:flex flex-col text-left min-w-0">
                      <div className="text-xs text-gray-600 whitespace-nowrap">Profile</div>
                      <div className="text-sm font-semibold whitespace-nowrap">{userName || 'User'}</div>
                    </div>
                    <svg className="w-4 h-4 text-gray-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </motion.button>
 
                  {/* Profile Dropdown */}
                  <AnimatePresence>
                    {isProfileDropdownOpen && (
                      <motion.div
                        className="absolute right-0 mt-2 w-56 bg-white rounded-lg shadow-lg border border-gray-200 py-2"
                        variants={dropdownVariants}
                        initial="closed"
                        animate="open"
                        exit="closed"
                        role="menu"
                        aria-orientation="vertical"
                      >
                        {profileMenuItems.map((item, index) => (
                          <motion.button
                            key={item.label}
                            onClick={() =>
                              item.label === "Log Out"
                                ? setShowLogoutConfirm(true)
                                : handleNavigation(item.route)
                            }
                            className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors duration-200"
                            role="menuitem"
                            whileHover={{ x: 4 }}
                            transition={{ duration: 0.2 }}
                          >
                            {item.label}
                          </motion.button>
                        ))}
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              </>
            ) : (
              /* Login Button - Only show when NOT logged in */
              <motion.button
                onClick={handleLoginClick}
                className="hidden lg:block bg-[#7299ff] text-white px-6 py-2 rounded-lg hover:bg-blue-600 transition-colors duration-200 font-medium"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                aria-label="Login"
              >
                Login
              </motion.button>
            )}
          </div>
        </div>
      </div>
 
      {/* Mobile Navigation Menu */}
      <AnimatePresence>
        {isMobileMenuOpen && (
          <motion.nav
            ref={mobileMenuRef}
            className="lg:hidden bg-white border-t border-gray-200"
            variants={menuVariants}
            initial="closed"
            animate="open"
            exit="closed"
            role="navigation"
            aria-label="Mobile navigation"
          >
            <div className="px-4 py-4 space-y-4">
              {/* Mobile Search Bar - Only show on mobile, hide on tablet+ */}
              <motion.div
                className="md:hidden"
                initial={{ opacity: 0, y: -10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.1, duration: 0.3 }}
              >
                <form onSubmit={handleSearch} className="relative">
                  <div className="flex items-center ps-5 pe-2 py-1 border border-solid bg-neutral-50 border-black border-opacity-10 rounded-[90px]">
                    <input
                      type="search"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      placeholder="Find for product"
                      className="flex-1 bg-transparent text-sm font-medium text-neutral-600 outline-none"
                      aria-label="Search for products"
                    />
                    <motion.button
                      type="submit"
                      className="ml-3 p-3 bg-[#7299ff] text-white rounded-full hover:bg-blue-600 transition-colors duration-200"
                      whileHover={{ scale: 1.1 }}
                      whileTap={{ scale: 0.95 }}
                      aria-label="Search"
                    >
                      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                      </svg>
                    </motion.button>
                  </div>
                </form>
              </motion.div>
 
              {/* Conditional Mobile Content based on login status */}
              {isLoggedIn ? (
                <>
                  {/* Mobile Icons Section - Only show when logged in */}
                  <motion.div
                    className="flex gap-4 justify-center py-2 border-b border-gray-200"
                    initial={{ opacity: 0, y: -10 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.2, duration: 0.3 }}
                  >
                    {/* Mobile Wishlist */}
                   <motion.button
  className="flex flex-col items-center gap-1 p-3 text-gray-700 hover:text-red-500 transition-colors duration-200"
 onClick={() => {
  const user = JSON.parse(localStorage.getItem("auth_user"));
  const plan_id = localStorage.getItem("plan_id");
 
  const isSubscribed = user?.subscription?.status === "active";
 
  if (isSubscribed || plan_id) {
    // If user has an active subscription or plan_id exists, go to wishlist
    navigate("/wishlist");
  } else {
    // Otherwise, redirect to subscription page
    navigate("/profile/subscription");
  }
}}
  whileHover={{ scale: 1.05 }}
  whileTap={{ scale: 0.95 }}
  aria-label="Wishlist"
>
  <svg
    className="w-6 h-6"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
    />
  </svg>
  <span className="text-xs font-medium">Wishlist</span>
</motion.button>
 
 
                    {/* Mobile Cart */}
                    <motion.button
                    className="flex flex-col items-center gap-1 p-3 text-gray-700 hover:text-black transition-colors duration-200"
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    onClick={() => {
  const user = JSON.parse(localStorage.getItem("auth_user"));
  const plan_id = localStorage.getItem("plan_id");
  const subIdRaw = localStorage.getItem("sub_cart");
  const isSubscribed = user?.subscription?.status === "active";

  // Safely parse sub_cart
  let subId;
  try {
    subId = subIdRaw ? JSON.parse(subIdRaw) : [];
  } catch {
    subId = [];
  }

  // Check for valid data
  const hasPlan = !!plan_id;
  const hasSubCart = Array.isArray(subId) ? subId.length > 0 : !!subId;

  if (isSubscribed || hasPlan || hasSubCart) {
    // If user already subscribed or has a plan/cart item
    navigate("/cartSection");
  } else {
    // Otherwise, go to subscription page
    navigate("/profile/subscription");
  }
}}

                    aria-label="Shopping cart"
                  >
                      <div className="relative">
                        <Box className="w-6 h-6" strokeWidth={2} />
                        {displayCount > 0 && (
                          <motion.div
                            className={`absolute -top-1 -right-1 flex items-center justify-center w-4 h-4 ${
                              scount > 0 ? "bg-green-400" : "bg-yellow-400"
                            } rounded-full`}
                            initial={{ scale: 0 }}
                            animate={{ scale: 1 }}
                            transition={{ delay: 0.3, type: "spring", stiffness: 500 }}
                          >
                            <span className="text-xs font-bold text-gray-800">
                              {displayCount}
                            </span>
                          </motion.div>
                        )}
                      </div>
                      <span className="text-xs font-medium">Cart</span>
                    </motion.button>
 
 
                    {/* Mobile Profile */}
                    <motion.button
                      className="flex flex-col items-center gap-1 p-3 text-gray-700 hover:text-black transition-colors duration-200"
                      whileHover={{ scale: 1.05 }}
                      whileTap={{ scale: 0.95 }}
                      onClick={(e) => toggleMobileProfile(e)}
                      aria-label="User profile"
                    >
                      <ProfileAvatar size="w-6 h-6" textSize="text-xs" />
                      <span className="text-xs font-medium">Profile</span>
                    </motion.button>
                  </motion.div>
 
                  {/* Navigation Links or Profile Menu - When logged in */}
                  <div className="space-y-2">
                    {showMobileProfile ? (
                      <>
                        {/* Back Button */}
                        <motion.button
                          className="flex items-center gap-2 px-4 py-3 text-gray-700 hover:bg-gray-100 rounded-lg font-medium transition-colors duration-200 w-full text-left"
                          onClick={(e) => {
                            e.stopPropagation();
                            setShowMobileProfile(false);
                          }}
                          initial={{ opacity: 0, x: -20 }}
                          animate={{ opacity: 1, x: 0 }}
                          transition={{ duration: 0.3 }}
                          whileHover={{ x: 4 }}
                        >
                          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                          </svg>
                          Back to Menu
                        </motion.button>
 
                        {/* Profile Menu Items */}
                        {profileMenuItems.map((item, index) => (
                          <motion.button
                            key={item.label}
                            onClick={() =>
                              item.label === "Log Out"
                                ? setShowLogoutConfirm(true)
                                : handleNavigation(item.route)
                            }
                            className="block w-full text-left px-4 py-3 text-gray-700 hover:bg-gray-100 rounded-lg font-medium transition-colors duration-200"
                            initial={{ opacity: 0, x: -20 }}
                            animate={{ opacity: 1, x: 0 }}
                            transition={{ delay: (index + 1) * 0.1, duration: 0.3 }}
                            whileHover={{ x: 4 }}
                          >
                            {item.label}
                          </motion.button>
                        ))}
                      </>
                    ) : (
                      <>
                        {/* Regular Navigation Items */}
                        {mobileMenuItems.map((item, index) => (
                          <motion.button
                            key={item.label}
                            onClick={() => handleNavigation(item.route)}
                            className="block w-full text-left px-4 py-3 text-gray-700 hover:bg-gray-100 rounded-lg font-medium transition-colors duration-200"
                            initial={{ opacity: 0, x: -20 }}
                            animate={{ opacity: 1, x: 0 }}
                            transition={{ delay: (index + 3) * 0.1, duration: 0.3 }}
                            whileHover={{ x: 4 }}
                          >
                            {item.label}
                          </motion.button>
                        ))}
                      </>
                    )}
                  </div>
                </>
              ) : (
                /* Mobile Login Section - Only show when NOT logged in */
                <motion.div
                  className="space-y-4"
                  initial={{ opacity: 0, y: -10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.2, duration: 0.3 }}
                >
                  {/* Mobile Login Button */}
                  <motion.button
                    onClick={handleLoginClick}
                    className="w-full bg-[#7299ff] text-white px-6 py-3 rounded-lg hover:bg-blue-600 transition-colors duration-200 font-medium text-center"
                    whileHover={{ scale: 1.02 }}
                    whileTap={{ scale: 0.98 }}
                  >
                    Login to Access Features
                  </motion.button>
 
                  {/* Regular Navigation Items for non-logged in users */}
                  <div className="space-y-2 border-t border-gray-200 pt-4">
                    {mobileMenuItems.map((item, index) => (
                      <motion.button
                        key={item.label}
                        onClick={() => handleNavigation(item.route)}
                        className="block w-full text-left px-4 py-3 text-gray-700 hover:bg-gray-100 rounded-lg font-medium transition-colors duration-200"
                        initial={{ opacity: 0, x: -20 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ delay: (index + 1) * 0.1, duration: 0.3 }}
                        whileHover={{ x: 4 }}
                      >
                        {item.label}
                      </motion.button>
                    ))}
                  </div>
                </motion.div>
              )}
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
 
      {/* Logout Confirmation Modal */}
      {showLogoutConfirm && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">
          <motion.div
            className="bg-white rounded-xl shadow-lg p-6 w-80 text-center"
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.9, opacity: 0 }}
            transition={{ duration: 0.2 }}
          >
            <h2 className="text-lg font-semibold text-gray-800 mb-4">
              Are you sure you want to logout?
            </h2>
            <div className="flex justify-center gap-4">
              <button
                onClick={() => setShowLogoutConfirm(false)}
                className="px-4 py-2 rounded-lg bg-gray-300 text-gray-700 hover:bg-gray-400 transition"
              >
                Cancel
              </button>
              <button
                onClick={handleLogout}
                className="px-4 py-2 rounded-lg bg-red-500 text-white hover:bg-red-600 transition"
              >
                Logout
              </button>
            </div>
          </motion.div>
        </div>
      )}
    </motion.header>
  );
};
 
export default Header;
 
 